import { Component } from '@angular/core';
import { ModalsService } from 'app/shared/services/modals.service';

@Component({
  selector: 'postbid-alert-component',
  templateUrl: './postbid-alert.component.html',
  styleUrls: ['./postbid-alert.component.scss']
})

export class PostbidAlertComponent {

  constructor(public modalsService: ModalsService) { }

  openPostBid() {
    this.modalsService.hideModal();
    setTimeout(() => {
      window.open("/settings/network");
    }, 400);
  }

}
